/**
 * Update guard — prevents auto-reload when the user is entering scores
 * or has unsaved form input.
 *
 * Exports:
 *   setEnteringScores(bool)  — score-entry screens set true on mount, false on unmount
 *   setFormDirty(key, bool)  — forms mark themselves dirty when user has unsaved input
 *   clearFormDirty(key)      — alias for setFormDirty(key, false)
 *   canAutoReload()          — true only if NOT entering scores AND no dirty forms
 */

let _enteringScores = false;
const _dirtyForms = new Set();

export function setEnteringScores(val) {
  _enteringScores = !!val;
}

export function setFormDirty(key, dirty) {
  if (dirty) _dirtyForms.add(key);
  else _dirtyForms.delete(key);
}

export function clearFormDirty(key) {
  _dirtyForms.delete(key);
}

export function canAutoReload() {
  return !_enteringScores && _dirtyForms.size === 0;
}
